
$('.js-collection-carousel').slick({
  dots: true,
  arrows:true,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  prevArrow: "<a href='#' class='slick-prev'><i class='carousel-arrow-prev'></i></a>",
  nextArrow: "<a href='#' class='slick-next'><i class='carousel-arrow-next'></i></a>",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        arrows:true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: false,
        arrows:true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows:true
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

 
// PDP CAROUSEL WITH THUMBS

// Enable on mobile devices only

/*
function pdpCarousel() {
  $('.js-slider-primary').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    arrows: false,
    fade:true,
    autoplay: false,
    speed: 300,
    lazyLoad: 'ondemand',
    asNavFor: '.js-slider-thumbs'});
  // Thumbnail/alternates slider for product page
  $('.js-slider-thumbs').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.js-slider-primary',
    dots: false,
    centerMode: true,
    focusOnSelect: true
  });

$('.single-option-selector').change(function() {
   setTimeout(() => {
  var selectedIndex = $('[data-product-gallery-selected="true"]').data('product-gallery-figure');
  $('.js-slider-primary').slick('slickGoTo', selectedIndex);
  console.log(selectedIndex);
  }, 500);
});
             
//keeps thumbnails active when changing main image, via mouse/touch drag/swipe
  
//   $('.js-slider-primary').on('afterChange', function(event, slick, currentSlide, nextSlide){
//     //remove all active class
//     $('.js-slider-thumbs .slick-slide').removeClass('slick-current');
//     //set active class for current slide
//     $('.js-slider-thumbs .slick-slide:not(.slick-cloned)').eq(currentSlide).addClass('slick-current');  
//   });
 
}
*/

// Initiate slider on page load

/*
if($(window).width() < 1020) {
    pdpCarousel();
} else {
  $('.js-slider-primary').slick('unslick');
  $('.js-slider-thumbs').slick('unslick');
}

// Update slider on window resize
$(window).resize(function(e){
  if($(window).width() < 1020) {
      pdpCarousel();
  } else {
    $('.js-slider-primary').slick('unslick');
    $('.js-slider-thumbs').slick('unslick');
  }
});
*/

$('.js-slider-thumbs').slick({
  slidesToShow: 7,
  slidesToScroll: 7,
  swipeToSlide: true,
  touchThreshold: 100,
  arrows: true,
  dots: false,
  centerMode: true
});

$(window).on('resize orientationchange', function() {
  $('.js-slider-thumbs').slick('resize');
});